/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.8.0-nightly.2026.11.1",
    versionName: "0.8.0-nightly.2026.11.1",
    versionChannel: "nightly",
    buildDate: "2026-11-01T00:14:45.172Z",
    commitHash: "3a08ba46fff8278c713eb5bc4d1882a29bdb7eee",
};
